import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, AlertCircle } from "lucide-react";

export default function LegalLayout({ title, subtitle, updatedAt, children, testid }) {
  const { t, i18n } = useTranslation();
  const isEn = (i18n.resolvedLanguage || i18n.language || "").slice(0, 2) === "en";
  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-10 md:py-16" data-testid={testid}>
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 text-xs text-stone-500 hover:text-stone-900 font-semibold uppercase tracking-widest mb-8"
          data-testid="legal-back-link"
        >
          <ArrowLeft className="w-3 h-3" />
          {t("common.back")}
        </Link>
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-3">
            {t("legal.progresDocument")}
          </div>
          <h1 className="font-display text-4xl md:text-5xl text-stone-900 leading-tight">
            {title}
          </h1>
          {subtitle && <p className="text-stone-500 mt-3 text-sm">{subtitle}</p>}
          {updatedAt && (
            <p className="text-xs text-stone-400 mt-4 font-mono">
              {t("legal.lastUpdated")}: {updatedAt}
            </p>
          )}
        </div>
        {isEn && (
          <div className="mb-8 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 flex items-start gap-3" data-testid="legal-en-notice">
            <AlertCircle className="w-5 h-5 text-amber-700 flex-shrink-0 mt-0.5" />
            <div className="text-xs text-amber-900 leading-relaxed">
              <div className="font-semibold mb-1">{t("legal.enNoticeTitle")}</div>
              <p>{t("legal.enNoticeBody")}</p>
              <p className="mt-2">
                {t("legal.enNoticeContact")}{" "}
                <a href="mailto:support@e-progres.pl" className="font-semibold underline">support@e-progres.pl</a>
              </p>
            </div>
          </div>
        )}
        <article className="legal-doc space-y-8 text-stone-700 text-sm md:text-[15px] leading-relaxed">
          {children}
        </article>
        <div className="mt-16 pt-8 border-t border-stone-200 text-xs text-stone-400 flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/regulamin" className="hover:text-stone-700">{t("legal.terms")}</Link>
          <Link to="/polityka-prywatnosci" className="hover:text-stone-700">{t("legal.privacyLong")}</Link>
          <Link to="/umowa-powierzenia" className="hover:text-stone-700">{t("legal.dpaLong")}</Link>
        </div>
      </main>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-display text-xl md:text-2xl text-stone-900 mb-3 leading-tight">
        {heading}
      </h2>
      <div className="space-y-3 text-stone-600">{children}</div>
    </section>
  );
}
